@if (
  {
    currentValue: currentValueChanges | async,
    changeValue: changeValueChanges | async,
    isChanged: isChangedChanges | async,
  };
  as data
) {
  @if (isExistent(data.currentValue) || isExistent(data.changeValue)) {
    @if (data.isChanged) {
      @if (isExistent(data.currentValue)) {
        <mr-content-change kind="previous">
          <ng-container *ngTemplateOutlet="currentValueDisplay"></ng-container>
        </mr-content-change>
      }
      <mr-content-change #newContentRef kind="new">
        <ng-container
          *ngTemplateOutlet="valueDisplay; context: { value: data.changeValue }"
        ></ng-container>
      </mr-content-change>
    } @else {
      <ng-container
        *ngTemplateOutlet="valueDisplay; context: { value: data.currentValue }"
      ></ng-container>
    }
  } @else {
    <span class="text-italic">Not entered</span>
  }
  <ng-template #currentValueDisplay>
    <ng-container
      *ngTemplateOutlet="valueDisplay; context: { value: data.currentValue }"
    ></ng-container>
  </ng-template>
}

<ng-template #valueDisplay let-value="value">
  @if (valueTemplate) {
    <ng-template
      [ngTemplateOutlet]="valueTemplate"
      [ngTemplateOutletContext]="{ value: value }"
    >
    </ng-template>
  } @else {
    {{ value }}
  }
</ng-template>
